export default "__VITE_ASSET__BY9Kf498__"